module.exports = __webpack_public_path__ + "static/media/cricket-banner.976f3d8f.webp";